// Bottom sheet for a tapped Terälehti word on touch screens, where hover, right click and drag don't exist.
import React, { useEffect } from 'react';
import { PeekBody } from './TeralehtiWordPeek';
import UiIcon from './ui/UiIcon';

const ACTIONS = [
  { tier: 'main', label: 'Pääsana' },
  { tier: 'bonus', label: 'Bonus' },
];

const TeralehtiWordSheet = ({ entry, tier, meta, locked, onMove, onClose }) => {
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  // A banned word comes back to where it came from; others go to the trash.
  const trashTier = tier === 'banned' ? (entry.src === 'k' ? 'bonus' : 'suggest') : 'banned';
  return (
    <div className="tl-sheet-backdrop" onClick={onClose}>
      <div className="tl-sheet" role="dialog" aria-label={entry.word} onClick={e => e.stopPropagation()}>
        <div className="tl-sheet-head">
          <div className="tl-peek-head">
            <strong>{entry.word}</strong>
            <span>{meta}</span>
          </div>
          <button className="btn-secondary tl-sheet-close" onClick={onClose} aria-label="Sulje"><UiIcon name="close" /></button>
        </div>
        <div className="tl-sheet-body"><PeekBody word={entry.word} /></div>
        {!locked && (
          <div className="tl-sheet-actions">
            {ACTIONS.map(a => (
              <button key={a.tier} className={a.tier === tier ? 'btn-primary' : 'btn-secondary'}
                disabled={a.tier === tier} onClick={() => onMove(a.tier)}>{a.label}</button>
            ))}
            <button className="btn-danger" onClick={() => onMove(trashTier)}>
              {tier === 'banned' ? 'Palauta' : 'Roskakoriin'}
            </button>
          </div>
        )}
        <a className="tl-sheet-link" href={`https://asiasanasto.fi/sana/${encodeURIComponent(entry.word)}`} target="_blank" rel="noopener noreferrer">
          Avaa Asiasanastossa
        </a>
      </div>
    </div>
  );
};

export default TeralehtiWordSheet;
